import type { Organization } from '@local/common-lib';
import { FlashOn as QuickPatrolIcon } from '@mui/icons-material';
import { Button, CardContent, Stack, Typography } from '@mui/material';
import type { FC } from 'react';
import { NavLink } from '../../components/nav-link/nav-link.js';
import { CenterCard } from '../../components/page-layout/center-card.js';
import { useAxios } from '../../hooks/use-axios.js';
import { useAuthenticated } from '../../utils/auth/index.js';

export const NoScheduledPatrols: FC = () => {
  const auth = useAuthenticated();
  const [organization] = useAxios<Organization.Type>('/api/v1/my/organization');

  return (
    <CenterCard>
      <CardContent>
        <Typography gutterBottom variant="h6">
          No Patrols Scheduled
        </Typography>
        <Typography sx={{ mb: 4 }}>
          Currently there are no future patrols scheduled.
        </Typography>
        <Stack direction="column" spacing={3}>
          {auth.userInfo.hasRole('patroller') &&
            organization.data?.allowQuickPatrol && (
              <Button
                color="secondary"
                component={NavLink}
                startIcon={<QuickPatrolIcon />}
                to="/patrol/quick-patrol"
                variant="contained"
              >
                Quick Patrol
              </Button>
            )}
          {auth.userInfo.hasRole('admin') && (
            <Button component={NavLink} to="/patrol/new" variant="contained">
              Create Patrol Now
            </Button>
          )}
        </Stack>
      </CardContent>
    </CenterCard>
  );
};

export const NoPastPatrols: FC = () => {
  const auth = useAuthenticated();

  return (
    <CenterCard>
      <CardContent>
        <Typography gutterBottom variant="h6">
          No Past Patrols
        </Typography>
        <Typography sx={{ mb: 4 }}>
          No patrols were found in the past.
        </Typography>
        {auth.userInfo.hasRole('admin') && (
          <Button component={NavLink} to="/patrol/new" variant="contained">
            Create Patrol Now
          </Button>
        )}
      </CardContent>
    </CenterCard>
  );
};
